import React from 'react';

const Inicio = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: '#01025e' }}>
      <h2>Bienvenido</h2>
      <p>Selecciona una opción del menú para comenzar.</p>
    </div>
  );
};

export default Inicio;
